<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="error" class="mr-3">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>Confirma que deseja deletar a proposta?</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Ao deletar, será perdido o histórico dessa proposta e essa ação não
            poderá ser revertida.
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Deletar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { propostaApi } from "@/apis/proposta";

export default {
  name: "ModalDeletarProposta",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      this.setLoading(true);
      propostaApi
        .remove(this.payload.municipioPropostaId)
        .then(() => {
          this.$notification.success("Proposta deletada com sucesso!");
          this.$emit("onLoad");
          this.dialog = false;
        })
        .catch((err) => {
          this.$notification.error("Erro ao deletar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
  },
};
</script>
